export default "__VITE_ASSET__7dc0f590__"